/** Response shapes of GET /api/dashboard/overview and /api/dashboard/analytics. */

export type AnyChannel = 'WEB' | 'VIDEO' | 'PHONE';

export interface DashboardOverview {
  days: number;
  since: string;
  totals: { leads: number; interviewsCompleted: number; qualified: number; needsReview: number; avgHoursLeadToVerdict: number | null };
  channelMix: { phone: number; video: number; web: number };
  funnel: { imported: number; reached: number; interviewed: number; qualified: number; shortlisted: number };
  topDropOff: { from: string; to: string; lost: number; rate: number } | null;
  topKnockout: { message: string; count: number } | null;
  needsReview: Array<{ id: string; name: string; job: { id: string; title: string }; score: number | null; reason: string | null }>;
  activeJobs: Array<{ id: string; title: string; location: string; total: number; interviewed: number }>;
  liveNow: Array<{
    id: string;
    channel: AnyChannel;
    status: 'IN_PROGRESS' | 'RINGING';
    startedAt: string | null;
    candidate: { id: string; name: string; jobTitle: string };
  }>;
}

export interface DashboardAnalytics {
  days: number;
  since: string;
  scored: number;
  conversionBySource: Array<{ source: string; leads: number; interviewed: number; qualified: number; rate: number }>;
  scoreDistribution: Array<{ from: number; to: number; count: number }>;
  verdictByJob: Array<{ jobId: string; title: string; qualified: number; needsReview: number; notQualified: number }>;
  interviewsPerDay: Array<{ date: string; started: number; completed: number }>;
  avgInterviewSeconds: number | null;
  durationByChannel: Partial<Record<AnyChannel, number>>;
  knockoutFrequencies: Array<{ message: string; count: number }>;
}

export const CHANNEL_LABEL: Record<AnyChannel, string> = { WEB: 'Web', VIDEO: 'Video', PHONE: 'Phone' };

export function formatHours(h: number | null): string {
  if (h === null) return '—';
  if (h < 1) return `${Math.round(h * 60)}m`;
  if (h < 48) return `${h.toFixed(1)}h`;
  return `${(h / 24).toFixed(1)}d`;
}

export function initials(name: string | undefined | null): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] ?? '') + (parts.length > 1 ? (parts.at(-1)?.[0] ?? '') : '')).toUpperCase() || '?';
}
